import {AfterViewInit, Component, DestroyRef, inject, Input, OnDestroy, OnInit} from '@angular/core';
// import * as moment from 'moment';
import moment from 'moment';
import {AlertController, ModalController} from '@ionic/angular';
import {ActivatedRoute, Router} from '@angular/router';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {Api} from '../../../smoothr-web-app-core/api/api';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import {environment} from '../../../environments/environment';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {numberD, numberToCurrency, sleep} from '../../../smoothr-web-app-core/utils/utils';
import {NavigationService} from '../../services/navigation.service';
import {PaymentMethod} from 'src/smoothr-web-app-core/enums/PaymentMethod';
import Payment from 'src/smoothr-web-app-core/models/Payment';
import PromoCode from 'src/smoothr-web-app-core/models/PromoCode';

import {Socket} from 'ngx-socket-io';
import * as L from 'leaflet';
import polyline from '@mapbox/polyline';
import {Observable} from 'rxjs';
import Order from 'src/smoothr-web-app-core/models/Order';
import {OrderStatus} from 'src/smoothr-web-app-core/enums/OrderStatus';
import SmoothrDispatchLocation from 'src/smoothr-web-app-core/models/SmoothrDispatchLocation';
import {DeliveryStatus} from 'src/smoothr-web-app-core/enums/DeliveryStatus';
import {RequestEmailComponent} from './request-email/request-email.component';
import {SocketRole} from 'src/smoothr-web-app-core/models/SocketRoles';
import {HomePage} from '../home/home.page';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.page.html',
    styleUrls: ['payment-success.page.scss'],
})
export class PaymentSuccessPage implements OnInit, AfterViewInit, OnDestroy {
    private destroyRef = inject(DestroyRef);
    static url = 'payment/success';
    static urlWithPaymentParam = 'payment/success/:payment';

    @Input() name!: string;
    // public qrSubject = new BehaviorSubject<boolean>(false);
    // private delayDuration = 180000; // 3 min in milliseconds = 180000
    // private timeoutObservable$ = timer(this.delayDuration);
    // private timerSubscription: Subscription;

    moment = moment;
    OrderUtils = OrderUtils;
    pm = PaymentMethod;
    pt = PreorderType;
    orderVenue: Venue;
    error: any;
    orderId: string;
    environment = environment;
    numberToCurrency = numberToCurrency;
    loading = true;
    paymentData: Payment | any;
    promocode: PromoCode = null;
    paymentId: string = '';
    verifiedOrder: Order;
    private map: L.Map;
    private driverMarker: L.Marker;
    driverDispatch: SmoothrDispatchLocation = null;
    estimatedNewTime: string = '';
    currentPolyline: any;
    deliveryStatusEnum = DeliveryStatus;
    numberD = numberD;
    navigationDone = false;
    qrCodeString: string;
    orderStatusEnum = OrderStatus;
    // invoiceNumber : string = '';
    // status: string = '';
    constructor(
        private translate: TranslateService,
        protected repository: RepositoryService,
        private alertCtrl: AlertController,
        private router: Router,
        private snackbarCtrl: MatSnackBar,
        private route: ActivatedRoute,
        private analytics: AnalyticsService,
        private navigationService: NavigationService,
        private socket: Socket,
        private modalCtrl: ModalController
    ) {
    }

    // static async navigate(router: Router, order: string, payment: string) {
    // 	await router.navigate([this.url + '/' + payment], {
    // 		queryParams: {
    // 			order
    // 		}
    // 	});
    // }

    ionViewDidEnter() {
        this.repository.onOrderChange(null);
    }

    ngAfterViewInit(): void {
    }

    private async initMap(dispatch: SmoothrDispatchLocation) {
        // Ensure the map container exists

        if (!dispatch?.driverLocation?.latitude) {
            return;
        }
        const mapContainer = document.getElementById('map-item');
        console.log('INIT MAP', mapContainer);
        if (mapContainer) {
            this.driverDispatch = dispatch;
            await sleep(1000);
            this.map = L.map('map-item', {
                center: [dispatch.driverLocation.latitude, dispatch.driverLocation.longitude],
                zoom: 13,
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors',
            }).addTo(this.map);

            // Decode the polyline
            if (dispatch.geometry) {
                this.updatePolyline(dispatch.geometry);
            }
            const routeCoordinates = polyline.decode(dispatch.geometry);

            // Convert the coordinates to LatLng objects
            const routeLatLngs = routeCoordinates.map(coord => L.latLng(coord[0], coord[1]));

            // Create custom icons
            const startIcon = L.icon({
                iconUrl: 'assets/dean_and_david/delivery/start.svg',
                iconSize: [38, 38], // size of the icon
                iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
                popupAnchor: [0, -38], // point from which the popup should open relative to the iconAnchor
            });

            const endIcon = L.icon({
                iconUrl: 'assets/dean_and_david/delivery/final.svg',
                iconSize: [38, 38], // size of the icon
                iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
                popupAnchor: [0, -38], // point from which the popup should open relative to the iconAnchor
            });

            // Add start marker with custom icon
            let startPoint = routeLatLngs[0];
            if (this.orderVenue) {
                if (this.orderVenue?.location?.coordinates && this.orderVenue?.location?.coordinates.length > 0) {
                    startPoint = {
                        lat: this.orderVenue?.location?.coordinates[1],
                        lng: this.orderVenue?.location?.coordinates[0],
                    };
                    console.log('START POINT 2', startPoint);
                }
            }
            L.marker(startPoint, {icon: startIcon}).addTo(this.map).bindPopup('Start Point');

            // Add end marker with custom icon

            let endPoint = routeLatLngs[routeLatLngs.length - 1];

            if (this.verifiedOrder) {
                if (
                    this.verifiedOrder?.preorder?.type === PreorderType.DELIVERY &&
                    this.verifiedOrder?.preorder?.lat &&
                    this.verifiedOrder?.preorder?.lng
                ) {
                    endPoint = {
                        lat: this.verifiedOrder?.preorder?.lat,
                        lng: this.verifiedOrder?.preorder?.lng,
                    };
                }
            }
            L.marker(endPoint, {icon: endIcon}).addTo(this.map).bindPopup('End Point');
            if (dispatch.driverLocation) {
                this.updateDriverLocation(dispatch.driverLocation);
            }
            console.log('::::L::::', L, this.map);
        } else {
            console.error('Map container not found.');
        }
    }

    private updateDriverLocation(driverLocation: { latitude: number; longitude: number }, type: string = 'Car'): void {
        console.log('UPDAT DRIVER', driverLocation, this.driverMarker);

        if (this.driverMarker) {
            // Update the position of the existing marker
            this.driverMarker.setLatLng([driverLocation.latitude, driverLocation.longitude]);
        } else {
            // Create a new marker if it doesn't exist
            const driverIcon = L.icon({
                iconUrl: type == 'Car' ? 'assets/dean_and_david/delivery/car.svg' : 'assets/dean_and_david/delivery/driver.svg',
                iconSize: [35, 35], // size of the icon
                iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
                popupAnchor: [0, -38], // point from which the popup should open relative to the iconAnchor
            });
            console.log('Update Driver', this.map);
            if (this.map) {
                this.driverMarker = L.marker({
                    lat: driverLocation.latitude,
                    lng: driverLocation.longitude
                }, {icon: driverIcon})
                    .addTo(this.map)
                    .bindPopup('Driver');
            }
        }
    }

    ngOnInit(): void {
        if (localStorage.getItem('storeName')) {
            this.name = localStorage.getItem('storeName');
        }
        // this.updateQrByTimeout();
        this.route.queryParams.subscribe(params => {
            console.log({
                params,
            });
            if (this.repository._verifiedOrder && this.repository._verifiedOrder._id && !params.order) {
                this.orderId = this.repository._verifiedOrder._id;
            } else {
                this.orderId = params.order;
            }
            // if(params.qrcodescanned) {
            // 	this.status = 'qrcodescanned';
            // }
            this.reloadOrder();
        });
        this.route.params.subscribe(v => {
            console.log(v);
            if (v?.payment) {
                this.paymentId = v?.payment;
            }
        });
        // setTimeout(() => {
        // console.log('TEST');
        // this.invoiceNumber = this.repository._verifiedOrder.code;
        // console.log(this.paymentData.redirectUrls.success);
        // this.functionForTest()
        // }, 4000);
        // this.qrCodeString = this.paymentData.redirectUrls.success + '?qrcodescanned=true';
        // this.qrCodeString = `${environment.baseUrl}/payment/success/${this.paymentId}?order=${this.orderId}&qrcodescanned=true`;
        this.qrCodeString = `${environment.webAppUrl}/payment/success/${this.paymentId}?order=${this.orderId}`;
        // this.qrCodeString = `${environment.urlQrCode}/payment/success/${this.paymentId}?order=${this.orderId}`;
    }

    ngOnDestroy(): void {
        console.log('DESTROY');
        // if (this.timerSubscription) {
        // 	this.timerSubscription.unsubscribe();
        // }
    }

    async reloadOrder(attempt: number = 0, error = null) {
        if (attempt) await new Promise(resolve => setTimeout(() => resolve(true), 5000));

        this.error = null;
        this.loading = true;
        if (attempt > 3) {
            this.error = error ? error : this.translate.instant('payment_success_page.payment_error');
            this.snackbarCtrl.open(error, null, {
                duration: 2000,
            });
            this.loading = false;
            return;
        }
        if (attempt > 0) {
            await sleep(200);
        }
        try {
            const orderResponse = (await Api.getOrder(this.orderId)) as any;
            this.verifiedOrder = orderResponse.data;
            this.repository.verifiedOrder.emit(orderResponse.data);
            // console.log(orderResponse.data.payment);
            console.log(this.verifiedOrder);

            if (orderResponse?.data?.payment) {
                this.paymentData = (await Api.getPayment(orderResponse.data.payment)).data;
            } else {
                if (this.paymentId) {
                    this.paymentData = (await Api.getPayment(this.paymentId)).data;
                }
            }
            if (this.paymentData?.isMobileApp && !this.navigationDone) {
                if (this.isAndroid()) {
                    this.navigationDone = true;
                    this.redirectToApp();
                }
            }
            if (!this.repository._verifiedOrder.isPayed && this.paymentData?.method !== PaymentMethod.CASH && this.paymentData) {
                await this.reloadOrder(attempt + 1, this.translate.instant('payment_success_page.please_reload'));
                return;
            }
            this.analytics.paymentSuccess();
            if (orderResponse?.data?.promoCode) {
                this.promocode = await this.loadPromocode(orderResponse.data.promoCode);
            }
            try {
                if (this.repository._venue && this.repository._venue._id === this.repository._verifiedOrder.venue) {
                    this.orderVenue = this.repository._venue;
                } else {
                    this.orderVenue = (await Api.getLazyVenue(this.repository._verifiedOrder.venue)).data;
                }
                if (this.verifiedOrder?.dispatch?.geometry) {
                    this.initMap(this.verifiedOrder.dispatch);
                }
                // remove socket
                // if (orderResponse?.data.preorder?.type === PreorderType.TAKE_AWAY) {
                // 	setTimeout(() => {}, 2500);
                // 	this.startListenSocketEvents(this.orderVenue._id, this.verifiedOrder._id);
                // }
                // this.listenSocketOrders(this.orderVenue._id);
                //TODO: Testing

                this.error = false;
                this.loading = false;
            } catch (e) {
                console.error(e);
                await this.reloadOrder(attempt + 1, error ? error : e);
                return;
            }

        } catch (e) {
            console.error(e);
            await this.reloadOrder(attempt + 1, e);
            return;
        }
    }

    async loadPromocode(promocodeId: string) {
        try {
            return (await Api.getPromoCodeById(promocodeId)).data;
        } catch (e) {
            return null;
        }
    }

    async home() {
        if (this.loading) {
            return;
        }
        console.log(this.error);

        if (this.error) {
            this.reloadOrder();
            return;
        }

        this.loading = true;
        this.socket.disconnect();

        if (this.verifiedOrder.preorder.type !== PreorderType.TAKE_AWAY && this.verifiedOrder.tableNumber && this.verifiedOrder.venue) {
            this.navigationService.homeWithTable(this.verifiedOrder.venue, this.verifiedOrder.tableNumber);
            return;
        }

        await this.repository.cleanRepository();
        // await this.navigationService.home();
        await HomePage.navigate(this.router, this.repository, this.name);
        await Api.activateAndDeactivateDeliveryTracking(this.verifiedOrder._id, 'disable');
    }

    navigateToUrl(url: string) {
        if (url) {
            window.open(url, '_blank');
        }
    }

    async startListenSocketEvents(venueId: string, orderId: string) {
        console.log('START SOCKET');

        const roomId = `WEB_APP_${orderId}`;
        const test = roomId + '_' + venueId;

        // this.socket.emit('authenticate', [roomId], [venueId], (ack: any) => {
        // 	console.log('Socket authenticated for ', ack);
        // });

        this.authenticateSocket({
            roles: [SocketRole.COUNTER_DISPLAY, SocketRole.COUNTER_DISPLAY_MAIN],
            venueIds: [venueId],
        });

        this.socket.onAny(data => {
            console.log('Order Listening', data);
            // observer.next(data);
        });
        // this.joinRoom(orderId);
        this.socket.on('order', (data, result) => {
            // if(data?.order && data.type === '')
            // observer.next(data);
            if (result?.order) {
                this.verifiedOrder = result.order;
            }
            console.log('CHANGE ORDER', result);
        });
        this.socket.on(roomId, data => {
            console.log('Order Listening', data);
            // observer.next(data);
        });
        this.socket.on('live-tracking', async (data, value) => {
            console.log('LIVE TRACK', data, value);
            if (!this.map) {
                this.initMap(value.location);
            }
            await sleep(1000);
            if (value?.location?.driverLocation) {
                if (this.map) {
                    this.updateDriverLocation(value?.location?.driverLocation, value?.location?.vehicleProfile ?? '');
                } else {
                    setTimeout(() => {
                        this.updateDriverLocation(value?.location?.driverLocation, value?.location?.vehicleProfile ?? '');
                    }, 1000);
                }
            }
            if (value?.location?.estimatedDeliveryAt) {
                this.estimatedNewTime = value?.location?.estimatedDeliveryAt;
            }
            if (value?.location?.geometry) {
                this.updatePolyline(value?.location?.geometry);
            }
            // observer.next(data);
        });
        this.socket.on(test, data => {
            console.log('test', data);
        });
    }

    private updatePolyline(dispatchGeometry: string) {
        // Decode the new geometry
        const routeCoordinates = polyline.decode(dispatchGeometry);

        // Convert the coordinates to LatLng objects
        const routeLatLngs = routeCoordinates.map(coord => L.latLng(coord[0], coord[1]));
        console.log(routeLatLngs);

        // Clear the existing polyline from the map
        console.log('CURR AFTER BEFORE', this.currentPolyline);
        if (this.currentPolyline) {
            this.map.removeLayer(this.currentPolyline);
            this.currentPolyline = null;
        }
        console.log('CURR AFTER BEFORE', this.map);

        // Add the new route to the map

        this.currentPolyline = L.polyline(routeLatLngs, {color: 'blue'}).addTo(this.map);
        console.log('CURR AFTER', this.currentPolyline);

        // Fit the map bounds to the new route
        this.map.fitBounds(this.currentPolyline.getBounds());
    }

    onLiveTracking(): Observable<any> {
        return new Observable(observer => {
            this.socket.on('live-tracking', data => {
                console.log('LIVE TRACK', data);
                observer.next(data);
            });

            // Clean up the event listener when the observable is unsubscribed
            return () => this.socket.off('live-tracking');
        });
    }

    startDrawDispatch(dispatch: SmoothrDispatchLocation) {
        this.initMap(dispatch);
    }

    mapTime(time: any, isAsap: boolean = false) {
        if (!time) {
            return '';
        }
        if (isAsap && time) {
            return moment(time).format('HH:mm') + ' - ' + moment(time).add(20, 'minute').format('HH:mm');
        }
        return moment(time).format('HH : mm');
    }

    isAndroid() {
        return /Android/i.test(navigator.userAgent);
    }

    redirectToApp() {
        window.location.href = 'deananddavid://dev-dean-and-david.smoothr.de' + this.router.url;
    }

    async openRequestEmail() {
        await RequestEmailComponent.show(this.modalCtrl, this.paymentData, this.orderVenue);
    }

    getKioskNumber(externalLocationId: string): string {
        if (!externalLocationId) {
            return '';
        }
        const parts = externalLocationId.split(',');
        return parts.length > 1 ? parts[1] : externalLocationId;
    }

    getBlockNumber(externalLocationId: string): string {
        if (!externalLocationId) {
            return '';
        }
        const parts = externalLocationId.split(',');
        return parts.length > 1 ? parts[0] : externalLocationId;
    }

    private authenticateSocket(data: { roles: SocketRole[]; venueIds: string[] }): void {
        this.socket.emit('authenticate', data.roles, data.venueIds, (ack: any) => {
            console.log('Socket authenticated for ', ack, data);
        });
    }

    // public updateQrByTimeout() {
    // 	this.timerSubscription = this.timeoutObservable$.subscribe(() => {
    // 		this.qrSubject.next(true);
    // 	});
    // }

    private listenSocketOrders(venueId: string) {
        const connectEvent = 'connect';
        const orderEvent = 'venue-' + venueId + '-orders';

        if (this.socket.connect) {
            this.authenticateSocket({
                roles: [SocketRole.COUNTER_DISPLAY, SocketRole.COUNTER_DISPLAY_MAIN],
                venueIds: [venueId],
            });
        } else {
            // fallback якщо ще не підключений
            this.socket.once(connectEvent, () => {
                this.authenticateSocket({
                    roles: [SocketRole.COUNTER_DISPLAY, SocketRole.COUNTER_DISPLAY_MAIN],
                    venueIds: [venueId],
                });
            });
        }

        const orderHandler = (data: any) => {
            if (data?.order && (data?.type == 'update' || data?.type == 'created')) {
                console.log('LISTEN', data);
                if (data?.order._id === this.verifiedOrder._id) {
                    this.repository.verifiedOrder.emit(data.order);
                }
                if (data.order.status === OrderStatus.DONE) {
                    this.socket.removeAllListeners();
                }
            }
        };

        this.socket.on(orderEvent, orderHandler);
    }
}
